import React from "react";
import SwitchSelector from "../switch-selector/SwitchSelector";
import { PlacementsContainer, PlacementsTitle } from "./PreviewPlacements.styled";
import { useTranslation } from "react-i18next";

const PreviewPlacements = ({
  orientationsOptions,
  orientationSelected,
  handleOrientationChange
}) => {
  const { t } = useTranslation();

  return (
    <PlacementsContainer>
      <PlacementsTitle>{t("Preview format")}</PlacementsTitle>
      <SwitchSelector
        options={orientationsOptions}
        selectedOption={orientationSelected}
        emitSelectionChange={handleOrientationChange}
      />
    </PlacementsContainer>
  );
};

export default PreviewPlacements;
